module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-EC_1.08e7f91b.jpg";